import { InjectionToken } from '@angular/core';

export const GA_MEASUREMENT_ID = new InjectionToken<string>('GA_MEASUREMENT_ID');
